import {useEffect, useState} from "react";
import {encryptoPlatform} from "../../utils/crypto";
import Loader from "../../components/loader/Loader";
import "./after-cap-update.css";
import {updateShopCap} from "../../api/updateShopCap";

const AfterCapUpdate = () => {
    const [isSuccess, setIsSuccess] = useState<boolean | null>(null);

    const updateCap = async (paymentToken: string, chargeId: string) => {
        const response = await updateShopCap(paymentToken, chargeId);
        const isSuccess = response?.data.state === 'success';
        setIsSuccess(isSuccess);
        if(isSuccess) {
            window.close();
        }
    }

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        console.log("params: ", params);
        const paymentToken = params.get("c");
        const chargeId = params.get("charge_id");
        if(paymentToken && chargeId) {
            updateCap(paymentToken, chargeId);
        }
    }, []);

    return (
        <div className="temp-page-container">
            <div className="temp-page">
                {isSuccess !== null ? <div>{isSuccess ? 'Cap was successfully updated' : 'Cap update failed'}</div> : null}
                {isSuccess !== false ? <Loader size={96} label={isSuccess ? "Redirecting..." : "Updating cap..."} isFullPage={false} /> : null}
                {isSuccess ? <div className="temp-action" onClick={() => window.close()}>Still here? Click to close the payment window and return to your dashboard.</div> :
                    isSuccess === false ? <div className="temp-action" onClick={() => window.open('https://vuelve.co/contact-us', '_blank')}>Contact us for assistance in updating cap</div> : null}
            </div>
        </div>
    );
}

export default AfterCapUpdate;